import SearchInput from "../../../../components/fields/search-input/search-input";

export default function BlogHeroSection({className, ...props}) {

    return (
        <div className={`bg-[#F0F7FF]  lg:flex flex-row lg:pl-[7rem]  ${className}`}>
            <div className={"flex flex-col gap-3 justify-center items-center lg:items-start lg:my-[7rem] flex-[2]"}>
                <p className={"text-[2rem] 2xl:text-[2.5rem] 3xl:text-[3.3125rem] font-poppins font-extrabold text-black"}>
                    Read Our <span className={"text-tertiary-900"}>Blogs!</span>

                </p>
                <div className={"flex flex-row "}>
                    <div className={"w-[350px]"}>
                        <SearchInput
                            placeholder={"Search Blogs"}
                            {...props}

                        />
                    </div>
                </div>
            </div>
            <div className={'flex-[2] hidden lg:flex justify-end items-end '}>
                <div className={"relative flex  "}>
                    <img src={"/images/halfCircle.svg"} alt={"bg"}/>
                    <div className={"absolute bottom-0 w-full"}>
                        <img src={"/images/communityperson.png"} className={"w-[80%] xl:w-auto m-auto "}
                             alt={"person"}/>

                    </div>
                </div>


            </div>
            <div className={"flex-1 hidden lg:block"}>
                <img src={"/images/handscomm.png"} className={" w-[80%] 2xl:w-auto"} alt={"hands"}/>

            </div>
        </div>

    )
}